import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-campaign-numerical-analytics',
    templateUrl: './campaign-numerical-analytics.component.html',
    styleUrls: ['./campaign-numerical-analytics.component.scss']
})
export class CampaignNumericalAnalyticsComponent {
    @Input() campaignDetailsInfo = [];
    @Input() campaignNumericalMetrics = [];
    @Input() loading = false;
}
